module.exports = __webpack_public_path__ + "./kit/docs/img/icon-enum.2a758ce30e53b63bb53694458327b717.svg";